export default __webpack_public_path__ + "static/media/wi-night-alt-cloudy.da42fbe0.svg";